import React from "react";
import { Button, Form, Heading, Modal, TextInput } from "blueprints2";
import { injectIntl, FormattedMessage } from "react-intl";

function CreateCredential({
  visible,
  setVisible,
  change,
  createCred,
  intl,
  error,
  isCredentialPosting
}) {
  return (
    <Modal
      isVisible={visible}
      onClose={() => setVisible(false)}
      className="w-1/4"
    >
      <Heading level={3}>
        <FormattedMessage id="applications.form.create.title" />
      </Heading>

      <Form
        onChange={(e) => change(e)}
        onSubmit={(e) => createCred(e)}
        className="w-full"
      >
        <TextInput
          placeholder={intl.formatMessage({
            id: "applications.form.name",
            defaultMessage: "Name",
          })}
          hasError={!!error}
          helperText={error}
          hasHiddenLabel
          name="name"
          className="w-full"
        />

        <Button isLoading={isCredentialPosting} type="submit" className="ml-0">
          <FormattedMessage id="applications.form.create.submit" />
        </Button>
      </Form>
    </Modal>
  );
}

export default injectIntl(CreateCredential);
